import { PodcastTemplateConfig } from 'redux/middleware/api/podcast-service';
import { IntroOutroState } from '../types';

export const getIntroOutro = (
  config: PodcastTemplateConfig,
): IntroOutroState => {
  const { edgeVideos } = config;
  const { intro, outro } = edgeVideos ?? {};
  return {
    intro: intro ? { id: intro.videoId, loaded: false } : undefined,
    outro: outro ? { id: outro.videoId, loaded: false } : undefined,
  };
};
